import { render, staticRenderFns } from "./priceRequestEditSalesPriceDialog.vue?vue&type=template&id=38518e05&"
import script from "./priceRequestEditSalesPriceDialog.vue?vue&type=script&lang=js&"
export * from "./priceRequestEditSalesPriceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports